{
    "locale": "fi-FI",
    "General": {
        "OrText": "Tai",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Siirry My Hubertiin"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Luo uusi tili",
        "ButtonText_SignInToYourAccount": "Kirjaudu tilillesi",
        "ButtonText_StartInterviewWithoutSigningUp": "Aloita haastattelu ilman rekisteröitymistä",
        "ButtonText_StartInterviewWithoutSigningIn": "Aloita haastattelu ilman kirjautumista",
        "Navlink_Dashboard": "Hallintapaneeli",
        "Navlink_MyInterviews": "Minun haastattelut",
        "Navlink_LearnWithHubert": "Opi Hubertin kanssa",
        "Navlink_HelpCenter": "Tukikeskus",
        "MyProfile": "Minun profiili",
        "LogOut": "Kirjaudu ulos"
    },
    "Login": {
        "MainTitle": "Katso Hubert-haastattelusi tulokset",
        "Subtitle": "Kirjaudu sisään nähdäksesi tulokset, saadaksesi palautetta, lukeaksesi neuvoja ja paljon muuta.",
        "LoginTitle": "Kirjaudu sisään Hubert-tilillesi",
        "Label_Email": "Sähköposti",
        "Label_Password": "Salasana",
        "ButtonText_SignIn": "Kirjaudu sisään",
        "ButtonText_ForgotPassword": "Unohditko salasanasi?",
        "ButtonText_ContinueWithGoogle": "Jatka Googlella",
        "ButtonText_ContinueWithAppleID": "Jatka Apple ID:llä",
        "ButtonText_ContinueWithFacebook": "Jatka Facebookilla",
        "OrSeparator": "Tai",
        "Error_Email_Required": "Sähköposti vaaditaan.",
        "Error_Email_Invalid": "Syötä kelvollinen sähköpostiosoite.",
        "Error_Password_Required": "Salasana vaaditaan.",
        "Error_Use_Same_Email_As_Interview": "Käytä samaa sähköpostiosoitetta, jonka annoit haastattelussa."
    },
    "Registration": {
        "MainTitle": "Katso Hubert-haastattelusi tulokset",
        "Subtitle": "Rekisteröidy nähdäksesi tulokset, saadaksesi palautetta, lukeaksesi neuvoja ja paljon muuta.",
        "RegistrationTitle": "Luo Hubert-tili",
        "BenefitsBox_Title": "Voit",
        "BenefitsBox_Point1": "Päästä käsiksi haastatteluhistoriaasi",
        "BenefitsBox_Point2": "Saada palautetta haastatteluistasi",
        "BenefitsBox_Point3": "Käyttää vastauksia uudelleen uusissa haastatteluissa",
        "BenefitsBox_Point4": "Saada haastatteluneuvoja",
        "BenefitsBox_Point5": "Lukea urakäsikirjoja",
        "BenefitsBox_Point6": "Ja paljon muuta",
        "Label_FirstName": "Etunimi",
        "Label_LastName": "Sukunimi",
        "Label_Email": "Sähköposti",
        "Label_Password": "Salasana",
        "Label_PhoneNumber": "Puhelinnumero",
        "Label_TermsOfService": "Hyväksyn",
        "Label_TermsOfServiceLink": "Tietosuojakäytännön ja käyttöehdot",
        "Placeholder_CountryCode": "Valitse maatunnus",
        "Placeholder_PhoneNumber": "Esim. 0401234567",
        "HelpText_Password": "Salasanan tulee olla vähintään 6 merkkiä pitkä.",
        "ButtonText_SignUp": "Rekisteröidy",
        "ButtonText_SignUpWithGoogle": "Rekisteröidy Googlella",
        "ButtonText_SignUpWithAppleID": "Rekisteröidy Apple ID:llä",
        "ButtonText_SignUpWithFacebook": "Rekisteröidy Facebookilla",
        "OrSeparator": "Tai",
        "Error_FirstName_Required": "Etunimi on pakollinen.",
        "Error_LastName_Required": "Sukunimi on pakollinen.",
        "Error_Email_Required": "Sähköposti on pakollinen.",
        "Error_Email_Invalid": "Anna kelvollinen sähköposti.",
        "Error_Email_Exists": "Sähköposti on jo käytössä.",
        "Error_Password_Required": "Salasana on pakollinen.",
        "Error_Password_6_Characters": "Salasanan on oltava vähintään 6 merkkiä pitkä.",
        "Error_PhoneNumber_Required": "Puhelinnumero on pakollinen.",
        "Error_PhoneNumber_Invalid": "Puhelinnumero ei ole kelvollinen.",
        "Error_PrivacyPolicyCheck_Required": "Tietosuojakäytäntö ja käyttöehdot on hyväksyttävä."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Osallistuaksesi haastatteluun sinun tulee hyväksyä Hubertin käyttöehdot. Merkitse vain valintaruutu jatkaaksesi.",
        "Subtitle_AfterInterviewCompleted": "Rekisteröidy nähdäksesi tulokset, saadaksesi palautetta, lukeaksesi neuvoja ja paljon muuta.",
        "PrivacyPolicyText": "Painamalla rekisteröidy hyväksyt",
        "PrivacyPolicyLink": "Tietosuojakäytännön ja käyttöehdot",
        "ButtonText_SignUp": "Rekisteröidy ja siirry haastatteluun",
        "ButtonText_SignUpNormal": "Rekisteröidy",
        "ButtonText_SignInInstead": "Klikkaa tästä kirjautuaksesi sisään"
    },
    "LoginInviteEmail": {
        "Subtitle": "Kirjaudu sisään nähdäksesi tulokset, saadaksesi palautetta, lukeaksesi neuvoja ja paljon muuta."
    },
    "AppMessages": {
        "internal-server-error": "Odottamaton virhe tapahtui.",
        "invalid-credentials": "Virheelliset tunnistetiedot. Yritä uudelleen.",
        "user-not-found": "Virheelliset tunnistetiedot. Yritä uudelleen.",
        "account-not-found": "Virheellinen tili. Yritä uudelleen.",
        "verify-email-title": "Vahvista sähköpostisi",
        "verify-email-subtitle": "Tarkista sähköpostisi vahvistaaksesi tilisi.",
        "email-not-verified-title": "Sähköpostia ei ole vahvistettu",
        "email-not-verified-subtitle": "Tarkista sähköpostisi vahvistaaksesi tilisi.",
        "verifying-email-title": "Sähköpostia vahvistetaan",
        "verifying-email-subtitle": "Odota hetki...",
        "sign-in-title": "Kirjaudutaan sisään",
        "sign-in-subtitle": "Odota hetki...",
        "server-error": "Jotain meni pieleen.",
        "hubert-user-exists": "Tili on jo olemassa.",
        "account-exists": "Tili on jo olemassa.",
        "email-verified": "Sähköpostisi on vahvistettu.",
        "email-is-taken": "Sähköposti on jo käytössä.",
        "re-enter-password": "Käytä salasanaasi kirjautuaksesi sisään",
        "password-reset": "Salasanasi on vaihdettu.",
        "re-enter-new-password": "Käytä uutta salasanaasi kirjautuaksesi sisään",
        "invalid-invitation": "Virheellinen kutsu.",
        "invalid-code": "Virheellinen vahvistuskoodi.",
        "email-already-verified": "Sähköposti on jo vahvistettu.",
        "email-mismatch-title": "Sähköpostiosoite ei täsmää",
        "email-mismatch-subtitle": "Käytä samaa sähköpostiosoitetta, jota käytit työhakemuksessa."
    },
    "TransitionPage": {
        "loading-title": "Ladataan...",
        "loading-subtitle": "Valmistellaan tietoja...",
        "logout-title": "Ladataan...",
        "logout-subtitle": "Kirjaudut ulos..."
    },
    "ImpersonationPage": {
        "loading-title": "Ladataan...",
        "loading-subtitle": "Valmistellaan tietoja..."
    },
    "ProcessInvitation": {
        "loading-title": "Ladataan...",
        "loading-subtitle": "Odota hetki, kun lataamme haastattelusi.",
        "InvitationNotFound": "Emme löydä haastatteluasi.",
        "InvitationExpired": "Tämä linkki haastatteluun on vanhentunut.",
        "InvitationExpired_Description1": "Avaa haastattelu osoitteesta.",
        "InvitationExpired_Description2": "tai ota yhteyttä rekrytoijaasi.",
        "InvitationInvalid": "Tämä kutsulinkki on virheellinen.",
        "InterviewCompleted": "Tämä haastattelu on jo suoritettu."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Minun haastattelut",
            "TableHead_Employer": "Työnantaja",
            "TableHead_Job": "Työpaikka",
            "TableHead_Status": "Tila",
            "TableHead_ApplicationDate": "Hakupäivämäärä",
            "TableBody_StartInterview": "Haastattelua ei ole suoritettu. Klikkaa tästä aloittaaksesi tai jatkaaksesi haastattelua.",
            "TableBody_NotScored": "Haastattelu on valmis. Tulokset ovat saatavilla pian.",
            "TableBody_Details": "Klikkaa tästä nähdäksesi haastattelun tulokset ja lisätietoja.",
            "ApplicationDate_Invited": "Kutsuttu",
            "ApplicationDate_MinuteAgo": "minuutti sitten",
            "ApplicationDate_MinutesAgo": "minuuttia sitten",
            "ApplicationDate_HourAgo": "tunti sitten",
            "ApplicationDate_HoursAgo": "tuntia sitten",
            "ApplicationDate_DayAgo": "päivä sitten",
            "ApplicationDate_DaysAgo": "päivää sitten",
            "ButtonText_SeeAllInterviews": "Näytä kaikki haastattelut",
            "ButtonText_Details": "Tiedot",
            "ButtonText_StartInterview": "Siirry haastatteluun",
            "ButtonText_NotScored": "Tuloksia odotetaan",
            "NoInterviews_Message": "Sinulla ei ole aikaisempia tai tulevia haastatteluja."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Tällä hetkellä ei ole saatavilla työpaikkailmoituksia. Tarkista myöhemmin uudelleen."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Minun ura",
            "Subtitle": "Valitse haastattelu nähdäksesi arvioinnin ja mahdollisuutesi.",
            "MostRecentInterview": "Viimeisin haastattelu",
            "ToDo": "Tehtävät",
            "NoOngoingInterviews_Title": "Sinulla ei ole uusia haastattelukutsuja.",
            "NoOngoingInterviews_Subtitle": "Uudet Hubert-haastattelut näkyvät täällä, kun rekrytoijat aikatauluttavat ne.",
            "NoRecentInterviews_Title": "Sinulla ei ole tallennettuja aiempia haastatteluja.",
            "NoRecentInterviews_Subtitle": "Kun sinut kutsutaan haastatteluun rekrytoijien toimesta, se näkyy täällä.",
            "ButtonText_StartInterview": "Siirry haastatteluun",
            "ButtonText_NotScored": "Tuloksia odotetaan",
            "ButtonText_Details": "Tiedot"
        },
        "LearnWithHubert": {
            "Title": "Opi Hubertin kanssa",
            "Subtitle": "Saat neuvoja siitä, kuinka voit parantaa haastattelutaitojasi ja menestyä työelämässä.",
            "PickedForMe": "Viimeisimmät artikkelit",
            "ButtonText_SeeAllArticles": "Näytä kaikki artikkelit"
        },
        "HubertTip": {
            "Title": "Hubert-vinkki",
            "Subtitle": "Suorita haastattelut nopeammin",
            "Description": "Haetko uutta työtä samankaltaiseen rooliin, johon olet jo tehnyt Hubert-haastattelun? Voit käyttää aiempia vastauksiasi uudelleen ja säästää aikaa.",
            "ButtonText_ReadMoreTips": "Lue lisää vinkkejä"
        },
        "NewCandidateModalPopup": {
            "Title": "Kaikki valmista!",
            "DescriptionLine1": "Tilisi on nyt valmis.",
            "DescriptionLine2": "Hallitse haastatteluja ja profiiliasi. Katso tuloksesi, saa palautetta ja opi lisää haastatteluiden suorittamisesta.",
            "ButtonText_LetsGo": "Aloitetaan"
        },
        "InterviewCompletedModal": {
            "Title": "Hienoa työtä!",
            "Subtitle": "Olet suorittanut haastattelusi.",
            "Description": "Rekrytoijat tarkastelevat hakemukset ja antavat palautetta sähköpostitse tai puhelimitse heti, kun heillä on päivitys.",
            "ButtonText_Continue": "Jatka"
        },
        "LatestJobPostings": {
            "Title": "Viimeisimmät työpaikkailmoitukset",
            "Subtitle": "Tutustu Hubert-kumppaneiden juuri julkaisemiin työpaikkoihin."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Minun haastattelut",
        "MyInterviewsSection_Subtitle": "Valitse haastattelu nähdäksesi arvioinnin ja uramahdollisuutesi.",
        "MyInterviewsSection_ToDo": "Tehtävät"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Näytä kaikki haastattelut",
        "InterviewNotFound_Title": "Pääsy evätty",
        "InterviewNotFound_Description": "Yrität päästä käsiksi haastattelutietoihin, jotka eivät liity tiliisi.",
        "ButtonText_GoToAllInterviews": "Siirry omiin haastatteluihin",
        "InterviewDetails": {
            "Title": "Haastattelun tiedot",
            "ForRole": "Rooliin",
            "InterviewCompletedOn": "Haastattelu suoritettu {{date}} klo {{time}}"
        },
        "MyResult": {
            "Title": "Minun tulos",
            "Subtitle": "Arvioitu sopivuus",
            "ButtonText_LearnMore": "Näe, miten vastauksiasi arvioidaan",
            "GotPotential_Title": "Vahva potentiaali, vaatimus puuttuu",
            "GotPotential_Description": "Vastauksesi osoittavat vahvaa potentiaalia tähän rooliin. Tämän haastattelun perusteella et kuitenkaan välttämättä täytä yhtä tai useampaa tehtävän vaatimusta. Tämä voi vaikuttaa jatkoon pääsyyn riippuen rekrytoijan tarpeista ja hakijatilanteesta. Jos et etene seuraavaan vaiheeseen, se ei välttämättä tarkoita, ettet olisi hyvä hakija. Usein kyse on tämän tehtävän tarkoista vaatimuksista. Katso alla olevat kysymykset ja vinkit.",
            "GotPotential_DescriptionSecondary": "Hubertin arvio on suuntaa antava. Rekrytoija tekee lopullisen päätöksen, ja myös muut tekijät, kuten hakijoiden määrä, voivat vaikuttaa lopputulokseen.",
            "GreatMatch_Title": "Vahva sopivuus",
            "GreatMatch_Description": "Vastauksesi vastasivat hyvin sitä, mitä rekrytoijat yleensä etsivät tässä roolissa, ja täytät tehtävän vaatimukset. Erinomainen suoritus. Rekrytoija käy läpi kaikki hakijat ja päättää seuraavat vaiheet.",
            "GreatMatch_DescriptionSecondary": "Hubertin arvio on suuntaa antava. Rekrytoija tekee lopullisen päätöksen, ja myös muut tekijät, kuten hakijoiden määrä, voivat vaikuttaa lopputulokseen. Jos et etene seuraavaan vaiheeseen, se ei välttämättä tarkoita, ettet olisi hyvä hakija. Usein kyse on tämän tehtävän tarkoista vaatimuksista. Katso alla olevat kysymykset ja vinkit.",
            "OkMatch_Title": "Pätevä, lisää vaikuttavuutta",
            "OkMatch_Description": "Täytät työn vaatimukset. Erottuaksesi joukosta vastauksesi saattavat vaatia hieman enemmän selkeyttä ja yksityiskohtaisuutta verrattuna siihen, mitä rekrytoijat yleensä tähän rooliin hakevat. Tarkista vastauksesi alta ja katso, missä konkreettisen esimerkin tai lopputuloksen lisääminen voi nostaa pisteitäsi.",
            "OkMatch_DescriptionSecondary": "Hubertin arvio on suuntaa antava. Rekrytoija tekee lopullisen päätöksen, ja myös muut tekijät, kuten hakijoiden määrä, voivat vaikuttaa lopputulokseen.",
            "NotClearMatch_Title": "Ehkä ei oikea rooli juuri nyt",
            "NotClearMatch_Description": "Tämän haastattelun perusteella vastauksesi saattavat vastata vähemmän sitä, mitä rekrytoija tähän rooliin hakee, tai et ehkä täytä yhtä tai useampaa vaatimusta. Jos haluat parantaa, aloita alla olevista kysymyksistä. Pienet muutokset, tarkemmat yksityiskohdat ja selkeät lopputulokset voivat vaikuttaa suuresti ensi kerralla.",
            "NotClearMatch_DescriptionSecondary": "Hubertin arvio on suuntaa antava. Rekrytoija tekee lopullisen päätöksen, ja myös muut tekijät, kuten hakijoiden määrä, voivat vaikuttaa lopputulokseen."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Ammatilliset kokemukset, motivaatiot ja taidot",
            "QualifyingRequirements": "Tämän tehtävän pätevyysvaatimukset",
            "NotQualified_Title": "Parantamisen varaa",
            "NotQualified_Description": "Vastauksesi ovat saattaneet olla vähemmän yksityiskohtaisia tai tuloskeskeisiä kuin rekrytoija tähän rooliin odottaa. Katso alta korostetut kohdat, joissa konkreettisen esimerkin, omien toimien tai selkeän lopputuloksen lisääminen voi vahvistaa vastauksiasi.",
            "GreatResults_Title": "Vahvat vastaukset",
            "GreatResults_Description": "Vastauksesi osoittavat, että sovit hakemaasi tehtävään hyvin ja kommunikoit selkeästi. Jos jotakin vastausta voisi parantaa, se on korostettu alla.",
            "MeetingRequirements_Title": "Vaatimukset täyttyvät",
            "MeetingRequirements_Description": "Vastauksesi osoittavat, että täytät rekrytoijan asettamat vaatimukset tässä tehtävässä. Hyvä perusta.",
            "NotAllExpectationsMet_Title": "Yksi tai useampi vaatimus puuttuu",
            "NotAllExpectationsMet_Description": "Vastaustesi perusteella et ehkä täytä yhtä tai useampaa tämän tehtävän kelpoisuusvaatimusta, esimerkiksi sertifikaatteja, lupia, koulutustasoa tai vaadittuja kokemusvuosia.",
            "ButtonText_FindOutPossibleReasons": "Katso lisätiedot"
        },
        "ScriptFromInterview": {
            "Title": "Lue koko haastattelusi",
            "ButtonText_SeeWholeTranscript": "Lue haastattelu",
            "ButtonText_DeleteInterview": "Poista haastattelu",
            "Loading_Title": "Ladataan...",
            "Loading_Subtitle": "Odota hetki, haastattelusi latautuu."
        },
        "HowToImproveAtInterviews": {
            "Title": "Kuinka voit parantaa haastattelutaitoja",
            "Subtitle_Questions": "Tässä on kysymyksiä, joissa vastauksesi voisi mahdollisesti olla parempi.",
            "Subtitle_NoQuestions": "Emme löytäneet vastauksia, joissa olisi merkittävää parantamisen varaa. Tässä on parhaat tavat lisätä vaikuttavuutta.",
            "GreatMatch_Questions_Description": "Vaikka sovit hyvin tähän tehtävään, joitakin vastauksia voi vielä vahvistaa. Jos olemme tunnistaneet tällaisia, löydät ne alta. Noudata kysymystä edeltäviä ohjeita. Kun kuvaat tilannetta, kerro tilanne, mitä teit ja mikä oli lopputulos. Pelkkä 'OK' ei auta, kun pyydämme tarkentamaan. Vältä kuitenkin liian pitkiä vastauksia. Pyri selkeyteen ja konkreettisuuteen.",
            "GreatMatch_NoQuestions_Description": "Suoriuduit hyvin kysymyksistä. Hienoa työtä.",
            "OkMatch_Questions_Description": "Alla on kysymyksiä, joissa vastaustasi voisi parantaa. Noudata kysymystä edeltäviä ohjeita. Kun kuvaat tilannetta, kerro tilanne, mitä teit ja mikä oli lopputulos. Pelkkä 'OK' ei auta, kun pyydämme tarkentamaan. Vältä kuitenkin liian pitkiä vastauksia. Pyri selkeyteen ja konkreettisuuteen.",
            "OkMatch_NoQuestions_Description": "Vastauksesi olivat hyviä, mutta kilpailu voi olla kovaa. Tämä tarkoittaa, että hyvätkin vastaukset voivat jäädä keskitasolle.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Ensi kerralla pyri selkeyteen ja vaikuttavuuteen. Aloita lopputuloksesta, lisää yksi todellinen esimerkki ja pidä vastaus tiiviinä, tyypillisesti 3–6 lausetta. Ole tarkka siitä, mitä teit, miten teit sen ja mikä muuttui sen ansiosta.",
            "GotPotential_Questions_Description": "Vaikka vaikutat vahvalta ehdokkaalta, joitakin vastauksia voi vielä vahvistaa. Jos olemme tunnistaneet tällaisia, löydät ne alta. Noudata kysymystä edeltäviä ohjeita. Kun kuvaat tilannetta, kerro tilanne, mitä teit ja mikä oli lopputulos. Pelkkä 'OK' ei auta, kun pyydämme tarkentamaan. Vältä kuitenkin liian pitkiä vastauksia. Pyri selkeyteen ja konkreettisuuteen.",
            "GotPotential_NoQuestions_Description": "Emme löytäneet vastauksia, jotka kaipaisivat merkittävää parannusta ammatillisten taitojen ja motivaation osalta. Vastasit hyvin näihin aiheisiin.",
            "NotClearMatch_Questions_Description": "Alla on kysymyksiä, joissa vastaustasi voisi parantaa. Noudata kysymystä edeltäviä ohjeita. Kun kuvaat tilannetta, kerro tilanne, mitä teit ja mikä oli lopputulos. Pelkkä 'OK' ei auta, kun pyydämme tarkentamaan. Vältä kuitenkin liian pitkiä vastauksia. Pyri selkeyteen ja konkreettisuuteen.",
            "NotClearMatch_NoQuestions_Description": "Emme löytäneet yhtään suoranaisesti 'huonoa' vastausta. Kyse on enemmänkin yleisestä sopivuudesta roolin tarpeisiin. Jos kilpailu on kovaa, pienetkin erot ratkaisevat.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "Seuraavassa haastattelussa keskity konkreettisuuteen. Valitse yksi esimerkki per kysymys, selitä toimesi ja jaa lopputulos. Lyhyt ja tarkka on yleensä parempi kuin pitkä ja yleinen.",
            "Alert_WantMoreAdvice": "Haluatko lisää vinkkejä menestyäksesi Hubert-haastattelussa?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Tutustu yleiseen neuvonta-artikkeliimme"
        },
        "SimilarOffers": {
            "Title": "Samankaltaiset työtarjoukset"
        },
        "HowHubertScoresInterviews": {
            "Title": "Miten Hubert arvioi haastattelut?",
            "Description": "Alla on lyhyt kuvaus siitä, miten Hubert arvioi haastatteluvastauksia. Olemme myös lisänneet Rekrytointiprosessi-osion, jossa selitetään seuraavat vaiheet Hubert-haastattelun jälkeen.",
            "Tabs_PossibleOutcomes": "Mahdolliset tulokset",
            "Tabs_RecruitmentProcess": "Rekrytointiprosessi",
            "AssessedMatch_Title": "Arvioitu sopivuus",
            "AssessedMatch_Description": "Hubert arvioi, kuinka hyvin vastauksesi vastaavat rekrytoijien odotuksia tässä tehtävässä. Yhdessä roolin vaatimusten kanssa näet yhden alla olevista tuloksista.",
            "AssessedMatch_DescriptionSecondary": "Hubertin arvio on suuntaa antava. Rekrytoija tekee lopullisen päätöksen, ja myös muut tekijät, kuten hakijoiden määrä, voivat vaikuttaa lopputulokseen.",
            "GreatMatch_Title": "Vahva sopivuus",
            "GreatMatch_Description": "Vastauksesi vastasivat hyvin sitä, mitä rekrytoijat yleensä etsivät tässä roolissa, ja täytät työn vaatimukset. Hienoa työtä. Rekrytoija käy läpi kaikki hakijat ja päättää seuraavat vaiheet.",
            "GotPotential_Title": "Vahva potentiaali, vaatimus puuttuu",
            "GotPotential_Description": "Vastauksesi osoittavat vahvaa potentiaalia tähän rooliin. Tämän haastattelun perusteella et kuitenkaan välttämättä täytä yhtä tai useampaa tehtävän vaatimusta. Tämä voi vaikuttaa jatkoon pääsyyn riippuen rekrytoijan tarpeista ja hakijatilanteesta.",
            "OkMatch_Title": "Pätevä, lisää vaikuttavuutta",
            "OkMatch_Description": "Täytät työn vaatimukset. Erottuaksesi joukosta vastauksesi saattavat vaatia hieman enemmän selkeyttä ja yksityiskohtaisuutta. Käytä haastattelun palautetta vahvistaaksesi esimerkkejäsi tulevaisuudessa.",
            "NotClearMatch_Title": "Ehkä ei oikea rooli juuri nyt",
            "NotClearMatch_Description": "Tämän haastattelun perusteella vastauksesi saattavat vastata vähemmän sitä, mitä rekrytoija tähän rooliin hakee, tai et ehkä täytä yhtä tai useampaa vaatimusta. Tarkista vastauksesi ja katso, missä voit lisätä selkeyttä ja esimerkkejä.",
            "ProfessionalExperiences_Title": "Ammatillinen kokemus, motivaatiot ja taidot",
            "ProfessionalExperiences_Description": "Nämä kysymykset liittyvät aiempaan työkokemukseesi, motivaatioosi ja tehtävään liittyviin taitoihisi. Rekrytoijat päättävät, mitä kysymyksiä haastattelussa käytetään.",
            "GreatResults_Title": "Vahvat vastaukset",
            "GreatResults_Description": "Vastauksesi osoittavat, että sovit hyvin tähän rooliin ja kommunikoit selkeästi. Jos jotakin vastausta voisi parantaa, se näkyy korostettuna.",
            "NotQualified_Title": "Parantamisen varaa",
            "NotQualified_Description": "Vastauksesi ovat saattaneet olla vähemmän yksityiskohtaisia tai tuloskeskeisiä kuin rekrytoija odottaa. Etsi korostettuja kohtia, joissa konkreettisen esimerkin tai selkeän lopputuloksen lisääminen voi vahvistaa vastauksiasi.",
            "QualifyingRequirements_Title": "Tehtävän perus- ja pätevyysvaatimukset",
            "QualifyingRequirements_Description": "Nämä ovat kysymyksiä, joita rekrytoija on asettanut pätevyysvaatimuksiksi. Ne voivat olla esimerkiksi vaadittu sertifikaatti, ajokortti tai tietty määrä työkokemusta.",
            "MeetingRequirements_Title": "Vaatimukset täyttyvät",
            "MeetingRequirements_Description": "Vastauksesi osoittavat, että täytät rekrytoijan asettamat pätevyysvaatimukset. Hyvä perusta.",
            "NotAllExpectationsMet_Title": "Yksi tai useampi vaatimus puuttuu",
            "NotAllExpectationsMet_Description": "Vastaustesi perusteella et ehkä täytä yhtä tai useampaa tämän tehtävän kelpoisuusvaatimusta, esimerkiksi sertifikaatteja, lupia, koulutustasoa tai vaadittuja kokemusvuosia.",
            "RecruitmentProcess_Title": "Rekrytointiprosessi",
            "RecruitmentProcess_Description": "Hubertia käytetään yleensä rekrytointiprosessin ensimmäisenä vaiheena, kun hakijoita on paljon. Se mahdollistaa kaikille haastattelun suorittamisen ja itsestään kertomisen omin sanoin. Koska kysymykset ovat samat kaikille, prosessi on tasapuolinen. Hubert ei käytä tietoja kuten ikä, sukupuoli, etninen tausta, uskonto tai ulkonäkö, mikä vähentää tiedostamattoman syrjinnän riskiä.",
            "EventOne_Title": "Hubert haastattelee sinua",
            "EventOne_Description": "Suoritat haastattelun Hubertin kanssa silloin ja siellä, kun se sinulle parhaiten sopii. Aikarajoituksia ei ole, ja voit pitää tauon milloin tahansa.",
            "EventTwo_Title": "Haastattelusi arvioidaan",
            "EventTwo_Description": "Hubert arvioi vastauksesi modernilla teknologialla. Heti kun arviointi on valmis, tulokset näkyvät sinulle My Hubertissa ja rekrytoijalle heidän järjestelmässään.",
            "EventThree_Title": "Rekrytoija valitsee ehdokkaat seuraaviin vaiheisiin",
            "EventThree_Description": "Rekrytoijat näkevät järjestelmässään, kun uusi Hubert-tulos on saatavilla. He tarkistavat vastauksesi ja Hubertin arvion. Hubertin suuntaa antavan arvion ja oman harkintansa perusteella he päättävät jatkosta. Tämä voi olla puhelu, testi tai haastattelu. Joskus rekrytoijat voivat odottaa ennen päätöstä. Jos muut hakijat sopivat paremmin, hakemuksesi voidaan hylätä.",
            "ButtonText_Close": "Sulje"
        }
    },
    "MyProfile": {
        "Title": "Minun profiili",
        "MyDetails": {
            "Title": "Minun tiedot",
            "Label_FirstName": "Etunimi",
            "Label_LastName": "Sukunimi",
            "Label_Email": "Sähköposti",
            "Label_PhoneNumber": "Puhelinnumero",
            "ButtonText_UpdateDetails": "Päivitä tiedot",
            "Error_FirstName_Required": "Etunimi on pakollinen.",
            "Error_LastName_Required": "Sukunimi on pakollinen.",
            "Error_Email_Required": "Sähköposti on pakollinen.",
            "Error_Email_Invalid": "Anna kelvollinen sähköposti.",
            "Error_PhoneNumber_Invalid": "Puhelinnumero ei ole kelvollinen.",
            "Success_Details_Updated": "Profiili päivitetty."
        },
        "ChangePassword": {
            "Title": "Vaihda salasana",
            "Set_Password_Title": "Luo salasana",
            "Label_CurrentPassword": "Nykyinen salasana",
            "Label_NewPassword": "Uusi salasana",
            "Label_RepeatNewPassword": "Toista uusi salasana",
            "Alert_SignInAgain": "Kirjaudu uudelleen sisään asettaaksesi salasanan.",
            "ButtonText_UpdatePassword": "Päivitä salasana",
            "ButtonText_SetPassword": "Aseta salasana",
            "ButtonText_SignInAgain": "Kirjaudu uudelleen",
            "Error_CurrentPassword_Required": "Nykyinen salasana on pakollinen.",
            "Error_CurrentPassword_DoesntMatch": "Salasana ei täsmää nykyisen salasanan kanssa.",
            "Error_NewPassword_Required": "Uusi salasana on pakollinen.",
            "Error_NewPassword_6_Characters": "Uuden salasanan on oltava vähintään 6 merkkiä pitkä.",
            "Error_RepeatNewPassword_Required": "Toistettu uusi salasana on pakollinen.",
            "Error_RepeatNewPassword_DoesntMatch": "Salasana ei täsmää uuden salasanan kanssa.",
            "Success_Password_Changed": "Salasana päivitetty.",
            "Error_Invalid_CurrentPassword": "Virheellinen nykyinen salasana."
        },
        "NotificationPreferences": {
            "Title": "Ilmoitusasetukset",
            "Label_ReceiveUpdatesToggle": "Haluan vastaanottaa Hubertin päivityksiä.",
            "Label_ReceiveUpdatesToggleHelpText": "Saat uravinkkejä, haastatteluneuvoja ja paljon muuta."
        },
        "AccountRemoval": {
            "Title": "Tilin poistaminen",
            "ButtonText_RemoveMyAccount": "Poista tilini"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hei",
        "Subtitle": "Olet aloittamassa haastatteluasi.",
        "TipBox_Title": "Tässä muutamia vinkkejä avuksesi.",
        "TipBox_Tip1": "Tee haastattelu rauhallisessa paikassa, jotta voit keskittyä.",
        "TipBox_Tip2": "Vastaa tietokoneella ja näppäimistöllä (ellet ole tottunut kirjoittamaan paljon mobiililaitteella).",
        "TipBox_Tip3": "Ole mahdollisimman tarkka ja perusteellinen vastauksissasi. Hubert ja rekrytoijat haluavat oppia tuntemaan sinut.",
        "TipBox_Tip4": "Käytä niin paljon aikaa kuin tarvitset. Ei ole aikarajoituksia.",
        "TipBox_Tip5": "Voit pitää tauon milloin tahansa ja jatkaa siitä, mihin jäit.",
        "TipBox_Tip6": "Ole oma itsesi ja suhtaudu Hubert-haastatteluun samalla vakavuudella kuin oikeaan haastatteluun.",
        "CheckAdviceArticle_Text1": "Jos haluat lisää vinkkejä onnistuneeseen haastatteluun, tutustu tähän",
        "CheckAdviceArticle_Text2": "artikkeliin",
        "CheckAdviceArticle_Text3": "joka sisältää hyviä neuvoja.",
        "ReadyToGetStarted": "Oletko valmis aloittamaan?",
        "ORSeparator_Text": "Tai",
        "ButtonText_StartInterviewNow": "Aloita haastattelu nyt",
        "ButtonText_SetReminder": "En ole valmis, aseta muistutus",
        "PrivacyPolicyText": "Painamalla 'aloita haastattelu' hyväksyt",
        "PrivacyPolicyLink": "Tietosuojakäytännön ja käyttöehdot"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Hienoa työtä!",
        "CompletedAlert_Subtitle": "Olet suorittanut haastattelusi.",
        "CompletedAlert_Description": "Rekrytoijat tarkistavat kaikki hakemukset ja antavat palautetta sähköpostitse tai puhelimitse heti, kun heillä on päivitys.",
        "InterviewNotCompleted": "Tätä haastattelua ei ole suoritettu loppuun."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Tukikeskus",
            "Subtitle": "Löydä vastaukset useimmin kysyttyihin kysymyksiin Hubertista.",
            "Label_Search": "hae usein kysyttyjä kysymyksiä",
            "ButtonText_Search": "Hae"
        },
        "FAQSection": {
            "Tabs_All": "Kaikki",
            "Tabs_AboutHubertInterview": "Tietoa Hubert-haastattelusta",
            "Tabs_TechnicalSupport": "Tekninen tuki"
        },
        "StillHaveQuestion": {
            "Title": "Onko sinulla vielä kysyttävää?",
            "Description": "Autamme mielellämme.",
            "DropUsAEmail": "Lähetä meille sähköpostia osoitteeseen hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Voinko suorittaa haastatteluni puhelimitse?",
                    "a": "Hubert toimii tällä hetkellä vain chatin kautta. Jos sinulla on este, joka estää sinua suorittamasta haastattelua, ota suoraan yhteyttä työnantajaan."
                },
                {
                    "q": "Voinko tehdä haastattelun toisella kielellä?",
                    "a": "Joissakin haastatteluissamme on mahdollisuus valita kieli alussa. Jos vaihtoehtoa ei ole, kielen ymmärtäminen on todennäköisesti vaatimus. Lisäkysymyksissä ota yhteyttä rekrytoivaan yritykseen."
                },
                {
                    "q": "Saanko rangaistuksen lyhyistä vastauksista?",
                    "a": "Et, kunhan vastaat kysymyksiin asianmukaisesti. Vastausten minimipituutta ei ole asetettu, mutta yksityiskohdat auttavat."
                },
                {
                    "q": "Voinko käyttää aiempia vastauksiani uudelleen Hubertin haastattelussa?",
                    "a": "Kyllä, voit käyttää aiempia vastauksiasi uudelleen, jos olet kirjautunut My Hubertiin ja haet samanlaiseen rooliin."
                },
                {
                    "q": "Lukeeko ihminen haastatteluni?",
                    "a": "Kyllä, asiakkaamme tarkistavat haastattelut manuaalisesti."
                },
                {
                    "q": "Olen suorittanut haastattelun, mitä tapahtuu seuraavaksi?",
                    "a": "Tulokset lähetetään rekrytoijan järjestelmään. Rekrytoijat tarkistavat vastauksesi ja Hubertin arvion. Hubertin suuntaa antavan arvion ja oman harkintansa perusteella he päättävät jatkosta, kuten puhelusta tai haastattelusta."
                },
                {
                    "q": "Minulla on kysymyksiä rekrytointiprosessin seuraavista vaiheista, kehen minun tulisi ottaa yhteyttä?",
                    "a": "Ota yhteyttä yritykseen, johon hait työtä."
                },
                {
                    "q": "Miten varmistatte, ettei rekrytointiprosessiin tule puolueellisuutta?",
                    "a": "Puolueellisuuden vähentäminen on kriittistä. Koneena Hubert on johdonmukaisempi kuin ihminen. Mallimme on koulutettu monien asiantuntijoiden avulla. Hubert ei myöskään käytä tietoja kuten sukupuoli, ikä tai ulkonäkö, jotka voivat aiheuttaa vääristymiä."
                },
                {
                    "q": "Voinko tehdä haastattelun ihmisen kanssa Hubertin sijaan?",
                    "a": "Ota yhteyttä yritykseen, johon hait työtä, ja kysy tästä mahdollisuudesta."
                },
                {
                    "q": "Onko Hubert ihminen?",
                    "a": "Ei, Hubert on tietokonepohjainen haastattelu- ja analyysijärjestelmä."
                },
                {
                    "q": "Voinko muokata vastauksiani jälkeenpäin?",
                    "a": "Ei, aivan kuten oikeassa haastattelussa, et voi muuttaa vastauksiasi jälkikäteen."
                },
                {
                    "q": "Miten onnistun Hubertin haastattelussa?",
                    "a": "Lue kysymykset huolellisesti. Noudata ohjeita. Anna esimerkkejä omista kokemuksistasi ja ole rehellinen."
                },
                {
                    "q": "Tarvitsen työpaikan, kehen minun pitäisi ottaa yhteyttä?",
                    "a": "Ota yhteyttä yritykseen, josta hait tehtävää."
                },
                {
                    "q": "Olen suorittanut haastattelun, mutta en ole kuullut mitään sen jälkeen. Mitä minun pitäisi tehdä?",
                    "a": "Rekrytoijat päättävät jatkosta. Jos muut hakijat sopivat paremmin, hakemuksesi voidaan hylätä. Voit ottaa yhteyttä rekrytoijaan tiedustellaksesi tilannetta."
                },
                {
                    "q": "Minulla on paljon kokemusta, mutta en saanut työpaikkaa. Miksi?",
                    "a": "Kilpailu voi olla kovaa. Jos hakemuksesi hylättiin, voit kysyä syitä yritykseltä. Voit myös tarkistaa My Hubertin palautteen ja muut työpaikat."
                },
                {
                    "q": "Kuinka kauan haastattelu kestää?",
                    "a": "Se riippuu kysymysten määrästä. Yleensä 10–25 minuuttia. Älä kiirehdi. Voit pitää tauon."
                },
                {
                    "q": "Mistä voin lukea, miten tietojani käsitellään?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Miksi en näe aiempia Hubert-haastattelujani?",
                    "a": "Varmista, että käytit samaa sähköpostia hakemuksessa ja My Hubertiin kirjautumisessa (myös Google/Facebook-kirjautumisessa)."
                },
                {
                    "q": "Miksi en saanut sähköpostia haastattelustani?",
                    "a": "Tarkista roskaposti. Voit myös lisätä hubert@hubert.ai yhteystietoihin. Tai kirjaudu My Hubertiin löytääksesi linkin."
                },
                {
                    "q": "En löydä haastattelulinkkiä sähköpostistani.",
                    "a": "Tarkista roskaposti. Tai kirjaudu My Hubertiin ja etsi linkki 'Minun haastattelut' -osiosta."
                },
                {
                    "q": "Toimiiko haastattelu mobiililaitteilla?",
                    "a": "Kyllä! Suosittelemme kuitenkin tietokonetta, jos kirjoittaminen on sillä mukavampaa."
                },
                {
                    "q": "Haastattelu ei toimi, mitä minun pitäisi tehdä?",
                    "a": "Pahoittelemme. Lähetä sähköpostia osoitteeseen hubert@hubert.ai, niin autamme."
                },
                {
                    "q": "Haluan poistaa koko My Hubert -tilini, mitä minun pitäisi tehdä?",
                    "a": "Lähetä sähköpostia osoitteeseen hubert@hubert.ai, niin autamme."
                },
                {
                    "q": "Haastattelu keskeytyi, miten voin palata siihen?",
                    "a": "Klikkaa sähköpostikutsun linkkiä tai kirjaudu My Hubertiin ja valitse haastattelu."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Opi Hubertin kanssa",
            "Subtitle": "Ota selvää, kuinka voit parantaa mahdollisuuksiasi rekrytointiprosessissa ja menestyä paremmin työssäsi.",
            "Label_Search": "hae haastattelu- ja uravinkkejä",
            "ButtonText_Search": "Hae"
        },
        "TabSelector": {
            "MyFeed": "Minun syöte",
            "InterviewGuides": "Haastatteluoppaat",
            "CareerGuides": "Uraoppaat"
        },
        "NewestOnTheFeed": "Uusimmat syötteessä",
        "PickedForMe": "Viimeisimmät artikkelit",
        "InterviewGuides": "Haastatteluoppaat",
        "CareerGuides": "Uraoppaat"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Takaisin kaikkiin artikkeleihin"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Nollaa salasanasi",
        "ResetLinkAlert_Subtitle": "Klikkaa sähköpostiisi lähetettyä linkkiä asettaaksesi uuden salasanan.",
        "PasswordNotSetAlert_Message": "Salasanaa ei ole asetettu, kirjaudu sisään käyttäen",
        "ResetYourPassword": {
            "MainTitle": "Katso Hubert-haastattelusi tulokset",
            "Subtitle": "Kirjaudu sisään nähdäksesi tulokset, saadaksesi palautetta, lukeaksesi neuvoja ja paljon muuta.",
            "FormSectionTitle": "Nollaa salasanasi",
            "Label_NewPassword": "Uusi salasana",
            "Label_ConfirmNewPassword": "Vahvista uusi salasana",
            "Error_NewPassword_Required": "Anna uusi salasana.",
            "Error_Password_6_Characters": "Uuden salasanan on oltava vähintään 6 merkkiä pitkä.",
            "Error_ConfirmNewPassword_Required": "Sinun on vahvistettava uusi salasana.",
            "Error_ConfirmNewPassword_NotMatch": "Salasana ei täsmää uuden salasanan kanssa.",
            "Error_MalformedResetUrl": "Virheellinen turvakoodi. Yritä uudelleen.",
            "Error_ResetPasswordFailed": "Salasanan nollaamisessa tapahtui virhe. Yritä uudelleen.",
            "Error_WeakPassword": "Salasanan on oltava vähintään 6 merkkiä pitkä.",
            "Error_InvalidCode_Title": "Salasanan palautuspyyntö on vanhentunut tai virheellinen.",
            "Error_InvalidCode_Subtitle": "Yritä nollata salasanasi uudelleen.",
            "ButtonText_SetNewPassword": "Aseta uusi salasana & kirjaudu sisään",
            "ButtonText_RememberYourPassword": "Muistatko salasanasi?",
            "ButtonText_SignInInstead": "Kirjaudu sisään sen sijaan"
        }
    },
    "PageNotFound": {
        "Title": "Sivua ei löytynyt",
        "Description": "Emme löydä etsimääsi sivua.",
        "ButtonText_GoToDashboard": "Siirry hallintapaneeliin",
        "ButtonText_GoToLogin": "Siirry kirjautumiseen"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Vastausten uudelleenkäyttö ei ole vielä saatavilla tähän haastatteluun. Odotamme ominaisuuden olevan käytettävissä pian, mutta voit silti suorittaa haastattelun.",
        "DescriptionLine2": "Siirry haastatteluun napsauttamalla alla olevaa painiketta.",
        "ButtonText_TakeMeToTheInterview": "Vie minut haastatteluun"
    },
    "UnsubscribeFromEmails": {
        "Title": "Oletko varma?",
        "Subtitle": "Et enää saa sähköposteja tästä tehtävästä:",
        "SelectTheReason": "Valitse syy alla olevista vaihtoehdoista.",
        "ReasonText1": "Olen löytänyt toisen työpaikan.",
        "ReasonText2": "En ole enää kiinnostunut tästä tehtävästä.",
        "ReasonText3": "Muu syy",
        "ButtonText_Unsubscribe": "Peru sähköpostit tästä tehtävästä",
        "Placeholder_YourReason": "Syy",
        "Success_Title": "Olet onnistuneesti peruuttanut sähköpostit tästä tehtävästä.",
        "Loading": "Ladataan...",
        "Error_YourReason_Required": "Anna syy.",
        "Error_ServerIssue": "Peruutus epäonnistui palvelinvirheen vuoksi."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Yritä uudelleen"
    },
    "Outreach": {
        "CandidateNotFound": "Ehdokasta ei löytynyt",
        "CandidateNotFoundDesc": "Etsimiäsi haastattelutietoja ei löytynyt.",
        "InterviewEnded": "Haastattelu päättynyt",
        "InterviewEndedDesc1": "Tämä haastatteluistunto on päättynyt tai se ei ole enää käytettävissä.",
        "InterviewEndedDesc2": "Kiitos ajastasi. Jos sinulla on kysyttävää, ota yhteyttä rekrytointitiimiin.",
        "ReadyTitle": "Oletko valmis haastatteluun, {{firstName}}?",
        "InvitationDesc": "Hubert kutsuu sinut yrityksen {{companyName}} puolesta chattipohjaiseen haastatteluun, jonka suorittaminen kestää noin 1-2 minuuttia.",
        "Button_StartChat": "Aloita chattihaastattelu",
        "CancelNotice": "Aloittaminen tästä peruu tähän rooliin suunnitellun puhelun.",
        "PreferNotToContinue": "Etkö halua jatkaa?",
        "DeclineLabel": "En ole kiinnostunut tästä roolista. Älä soita tai lähetä minulle enää viestejä tästä tehtävästä.",
        "Button_ConfirmAndDecline": "Vahvista ja kieltäydy",
        "Processing": "Käsitellään...",
        "Toast_DeclineSuccess": "Haastattelusta kieltäydytty onnistuneesti",
        "Toast_CancelVoiceInfo": "Puhehaastattelu peruttu. Ominaisuus tulossa pian.",
        "Toast_CancelError": "Haastattelun peruuttaminen epäonnistui. Yritä uudelleen.",
        "Footer_WithdrawConsent": "Voit peruuttaa suostumuksesi milloin tahansa. Lue lisää ",
        "Footer_PrivacyPolicySuffix": ":n tietosuojaselosteesta",
        "Footer_And": " ja ",
        "Footer_HubertPrivacyLink": "Hubertin tietosuojaselosteesta ja käyttöehdoista",
        "Chat_InterviewWith": "Haastattelu yrityksen {{companyName}} kanssa",
        "Chat_StatusConnected": "Yhdistetty",
        "Chat_StatusError": "Virhe",
        "Chat_StatusDisconnected": "Katkaistu",
        "Chat_StatusConnecting": "Yhdistetään...",
        "Chat_ReadyToStart": "Valmis aloittamaan haastattelun?",
        "Chat_ButtonStart": "Aloita haastattelu",
        "Chat_SayHello": "Sano hei aloittaaksesi keskustelun.",
        "Chat_EmptyState": "Lähetä viesti aloittaaksesi haastattelun.",
        "Chat_SelectLanguage": "Valitse kieli",
        "Chat_Placeholder": "Kirjoita viestisi...",
        "Chat_ButtonSend": "Lähetä",
        "Chat_ButtonBack": "Takaisin",
        "LoadingCandidateDetails": "Ladataan ehdokkaan tietoja...",
        "FetchingCandidateDetails": "Haetaan ehdokkaan tietoja...",
        "Chat_StatusReady": "Odotetaan yhteyttä...",
        "Chat_ForbiddenError": "Tämä chattihaastattelu ei ole enää käytettävissä.",
        "Chat_GeneralError": "Chatin aloittaminen epäonnistui. Yritä uudelleen myöhemmin.",
        "Chat_SelectUiLanguage": "Valikon kieli",
        "Chat_InterviewTitle": "Työhaastattelu"
    }
}
